module.exports = __webpack_public_path__ + "static/img/icon1-3.1f3cf40a.svg";